import React from "react";
import { m } from "kremling";
import { CpCheckbox } from "@components";
import { Resource } from "../types";

type SelectCellProps = {
  selection: {
    type: "includes" | "excludes";
    byId: Record<string, boolean>;
    allSelected?: boolean;
  };
  resource: Resource;
  resourceIndex: number;
  onSelect: (
    event: React.ChangeEvent<HTMLInputElement>,
    resource: Resource,
    resourceIndex: number,
  ) => void;
  isDisabled?: boolean;
};

export function SelectCell({
  selection,
  resource,
  resourceIndex,
  onSelect,
  isDisabled,
}: SelectCellProps) {
  const isSelected = selection.byId[resource.id] || false;

  return (
    <CpCheckbox
      className={m("cp-data-table-cell-disabled-opacity", isDisabled)}
      disabled={isDisabled}
      checked={
        isDisabled
          ? false
          : selection.type === "excludes"
            ? !isSelected
            : selection.allSelected || isSelected
      }
      onChange={(value, event) =>
        onSelect(
          event as React.ChangeEvent<HTMLInputElement>,
          resource,
          resourceIndex,
        )
      }
    />
  );
}
